<template>
  <div>
    <v-layout align-center column>
      <p class="Text-Hero">
        Dapatkan Kemudahan Pinjaman Di Platform Dompet Kilat
      </p>
      <div class="Google-Play">
        <v-img
          class="Shape2GPlayImage"
          max-width="268px"
          contain
          src="../../assets/homepage/LOGO DOWNLOAD-04.png"
          @click="note = true"
        />
      </div>
      <v-dialog
        transition="dialog-bottom-transition"
        v-model="note"
        max-width="600"
      >
        <v-card>
          <v-card-title class="white--text text-body-1 popupTitle">
            Download Aplikasi Dompetkilat
          </v-card-title>
          <v-card-text>
            <div class="text-body-1 black--text px-2 mt-6">
              Anda akan mengunduh aplikasi DompetKilat, Pastikan anda
              <span class="red--text font-weight-bold"
                >sudah memiliki kode akses</span
              >
            </div>
            <div class="text-body-1 px-2 mt-6">
              Masukkan kode akses untuk melanjutkan
              <v-text-field
                class="mt-2"
                v-model="noteCode"
                label="Kode Akses"
                color="#D3352C"
                outlined
                dense
                required
              ></v-text-field>
              <strong
                v-if="noteError"
                class="text-body-2 red--text text--lighten-1"
                >Kode Akses Salah !!</strong
              >
            </div>
          </v-card-text>
          <v-divider class="mx-4" />
          <v-card-actions class="justify-end">
            <div class="pb-2">
              <v-btn
                class="white--text text-none"
                color="#D3352C"
                min-width="125"
                rounded
                @click="closeNote"
                >Batal</v-btn
              >
              <v-btn
                class="ml-4 text-none"
                min-width="125"
                outlined
                color="black"
                rounded
                @click="toDownload"
                >Selanjutnya</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <img
        src="../../assets/Pinjaman-Mobile/Hero.png"
        srcset="
          ../../assets/Pinjaman-Mobile/Hero@2x.png 2x,
          ../../assets/Pinjaman-Mobile/Hero@3x.png 3x
        "
        class="Hero"
      /> -->
    </v-layout>

    <description-mobile />
    <table-mobile />
    <v-layout align-center column>
      <h1 class="Section-Titlea">Testimonial Peminjam</h1>
      <testimonial-mobile :testi="testiPeminjam" />
    </v-layout>

    <pertanyaan-mobile />
  </div>
</template>
<script>
import axios from "axios";
import DescriptionMobile from "../../components/pinjaman/Description-Mobile.vue";
import PertanyaanMobile from "../../components/pinjaman/PertanyaanMobile.vue";
import TableMobile from "../../components/pinjaman/TableMobile.vue";
import TestimonialMobile from "../../components/pinjaman/TestimonialMobile.vue";
export default {
  components: {
    TableMobile,
    DescriptionMobile,
    TestimonialMobile,
    PertanyaanMobile,
  },
  data() {
    return {
      note: false,
      noteError: false,
      noteCode: "",
      testiPeminjam: [
        {
          name: "Ario",
          job: "Petambak Udang",
          desc: `Selama saya mendapatkan bantuan pinjaman dari Dompet Kilat, saya sangat terbantu, terutama dari sisi finansial. Memang masih ada beberapa kekurangan dalam sistem Dompet Kilat dan termasuk saya juga tentunya, namun anggotanya sangat open minded dan terbuka untuk bekerja mencari solusi sehingga beberapa kendala dapat diatasi bersama. Maju terus Dompet Kilat!!`,
          img: require("../../assets/pinjaman/user/image_testi_borrower_1.png"),
        },
        {
          name: "Mugiyo",
          job: "Petani",
          desc: `Saya sangat bersyukur bisa bekerja sama dengan Dompet Kilat. Pinjaman finansial tentunya sangat membantu usaha saya, tapi yang lebih bermanfaat adalah ekosistem yang dibangun oleh Dompet Kilat. Usaha saya berkembang pesat setelah bekerja sama dengan Dompet Kilat. Terima Kasih!`,
          img: require("../../assets/pinjaman/user/image_testi_borrower_2.png"),
        },
        {
          name: "Wiyudo",
          job: "Tambak Udang",
          desc: `Selama 3 tahun bekerja sama dengan Dompet Kilat, saya sangat terbantu karena kita bisa mengajukan pinjaman tanpa agunan. Dompet Kilat juga menyediakan ekosistem pendanaan yang sangat membantu dalam penyediaan kebutuhan. Terima kasih Dompet Kilat!`,
          img: "",
        },
        {
          name: "Muhammad Chandra ",
          job: "Security",
          desc: `Program pembiayaan seragam dari Dompet Kilat sangat membantu saya agar dapat bekerja menggunakan seragam security yang telah ditentukan oleh perusahaan. Prosesnya gampang dan cepat! Terima kasih Dompet Kilat.
`,
          img: "",
        },
        {
          name: "Tabrani",
          job: "Petani",
          desc: `Dompet Kilat bekerjasama dengan beberapa pihak diantaranya PT. Bayer, Indo Buana Berkah & asuransi yang dapat mendampingi kami para petani agar mendapatkan hasil yang maksimal. Terima kasih Dompet Kilat!
`,
          img: "",
        },
      ],
    };
  },

  methods: {
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    download(url, title) {
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch((err) => this.rollbar.debug(err));
    },
    toDownload() {
      if (this.noteCode === process.env.VUE_APP_DOWNLOAD_PASSWORD) {
        this.download(
          "https://ws-dk.dompetkilat.co.id/api/download",
          "DompetKilat_v3.0.apk"
        );
        this.noteCode = "";
        this.note = false;
        this.noteError = false;
      } else {
        this.noteError = true;
      }
    },
    closeNote() {
      this.note = false;
      this.noteCode = "";
      this.noteError = false;
    },
  },
};
</script>
<style scoped>
html,
body {
  width: 100%;
  overflow-x: hidden;
}
.Text-Hero {
  width: 328px;
  height: 90px;
  flex-grow: 0;
  margin: 40px auto 0 auto;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: -0.48px;
  text-align: center;
  color: #252525;
  position: absolute;
}
.Hero {
  width: 120%;
  max-width: 100%;
  /* height: 498px; */
  margin: -350px 0 49.7px;
  /* padding: 0 0 230px; */
  object-fit: contain;
}

.Section-Titlea {
  width: 328px;
  height: 23px;
  flex-grow: 0;
  margin: 40px 0 32px;
  font-family: Sora;
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Google-Play {
  z-index: 1;
  padding-top: 160px;
  padding-bottom: 60px;
}
</style>
